import * as React from 'react';
import  request  from '@/server/request';
import config from '@/server/config';
import './scss/form.scss';
import alert from '@/pages/components/common/alert';
// import UploadImg from '@/pages/components/uploadImg';

interface initProps{
	history: any,
}

class ComponentAuthStep2 extends React.Component <initProps , any> {
	constructor(props: any) {
		super(props);
		this.state = {
			// 是否是企业认证变更
			actiontype: '',
			visiblity: false,
			isSubmiting: false,
			form: {
				company: '', // 企业名称
				licenceCreditCode: '', // 社会信用代码
				bank: '', // 开户银行
				bankAccountNumber: '', // 银行账号
				phone: '', // 联系电话
				address: '', // 银行地址
				type: 0,
				authType: 0
			},
		}
	}

	componentDidMount() {
		let tempActiontype = '';
		const tempState = this.props.history.location.state;
		if(tempState && tempState.actiontype) {
			tempActiontype = tempState.actiontype;
		}
		if (tempActiontype) {
			this.setState({ actiontype: tempActiontype }, () => {
				this.initData();
			});
		} else {
			this.initData();
		}
	}

	render() {
		return (
			<div className="gray-bg">
				<div className="process">
					<div className="process-item active"> 
						<div className="num-warrrper">
							<span className="num">1</span>
						</div>
						<p className="title">工商信息</p>
					</div>
					<div className="process-item active"> 
						<div className="num-warrrper">
							<span className="num">2</span>
						</div>
						<p className="title">开票信息</p>
					</div>
					<div className="process-item"> 
						<div className="num-warrrper">
							<span className="num">3</span>
						</div>
						<p className="title">上传附件</p>
					</div>
				</div>
				<div className="default-form margin-down-default">
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>公司名称</label>
						<input 
							type="text" 
							placeholder="请输入公司名称" 
							className="text-right" 
							readOnly={true}
							value={this.state.form.company}/>
					</div>
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>社会信用代码</label>
						<input 
							type="text" 
							placeholder="请输入社会信用代码" 
							className="text-right" 
							readOnly={true}
							value={this.state.form.licenceCreditCode}/>
					</div>
				</div>

				<div className="default-form margin-down-default">
					<div className="form-input-warrper">
						<label className="label">开户银行</label>
						<input 
							type="text" 
							placeholder="请输入开户银行" 
							className="text-right" 
							value={this.state.form.bank}
							onChange={ (e:any) => this.setForm('bank', e.target.value) }/>
					</div>
					<div className="form-input-warrper">
						<label className="label">银行账号</label>
						<input 
							type="text" 
							placeholder="请输入银行账号" 
							className="text-right" 
							value={this.state.form.bankAccountNumber}
							onChange={ (e:any) => this.setForm('bankAccountNumber', e.target.value) }/>
					</div>
					<div className="form-input-warrper">
						<label className="label">联系电话</label>
						<input 
							type="text" 
							placeholder="请输入联系电话" 
							className="text-right" 
							value={this.state.form.phone}
							onChange={ (e:any) => this.setForm('phone', e.target.value) }/>
					</div>
					<div className="form-input-warrper">
						<label className="label">开票地址</label>
						<input 
							type="text" 
							placeholder="请输入开票地址" 
							className="text-right" 
							value={this.state.form.address}
							onChange={ (e:any) => this.setForm('address', e.target.value) }/>
					</div>
				</div>

				<div className="form-btn-warrrper clearfix">
					<button className="form-btn" onClick={() =>  this.submitForm() }>下一步</button>
					<button className="form-btn white" onClick={() => this.props.history.replace('/auth/step1', {actiontype: this.state.actiontype})}>返回上一步</button>
				</div>
			</div>
		)
	}

	// 返回初始化数据
	private async initData() {
		const r = await request({
			method: "get",
			url: `${config.CE}member/company/info?type=${this.state.actiontype}`,
		});

		if (r.code !== 1) {
			alert.open({
				promptText: r.msg,
			})
		} else {
			const {companyInfo, memberInfo} = r.obj;

			const checkNull = (data: any) => {
				return data ? data : '' 
			}

			let data: any;
			data = companyInfo !== null ? ((companyInfo.applyRecode && companyInfo.applyRecode.type === 2 || companyInfo.applyRecode.type ===4) ? companyInfo : memberInfo) :  memberInfo;

			const companyBanks = (companyInfo && companyInfo.companyBanks && companyInfo.companyBanks.length > 0) ? companyInfo.companyBanks[0] : {
				bank: '',
				bankAccountNumber: '',
				phone: '',
				address: ''
			};

			this.setState({
				form: {
					company: data ? checkNull(data.company) : '', // 企业名称
					licenceCreditCode: data ? checkNull(data.licenceCreditCode) : '', // 社会信用代码
					bank: companyBanks ? checkNull(companyBanks.bank) : '', // 开户银行
					bankAccountNumber: companyBanks ? checkNull(companyBanks.bankAccountNumber) : '', // 银行账号
					phone:  companyBanks ? checkNull(companyBanks.phone) : '', // 联系电话
					address: companyBanks ? checkNull(companyBanks.address) : '', // 银行地址
					type: 0,
					authType: this.state.actiontype || 0
				}
			})

			
		}
	}

	// 表单赋值
	private setForm(name?: string, val?: any) {
		if(!name) {
			return ;
		}
		this.state.form[name] = val;
		this.setState({
			form: { 
				...this.state.form,
			} 
		})
	}

	private checkForm() {
		/**
		if(this.state.form.bank.toString().replace(/\s/gi, '') === '') {
			alert.open({
	    		promptText: '请输入开户银行',
	    	})
			return ;
		}
		if(this.state.form.bankAccountNumber.toString().replace(/\s/gi, '') === '') {
			alert.open({
	    		promptText: '请输入银行账号',
	    	})
			return ;
		} 
		if(this.state.form.phone.toString().replace(/\s/gi, '') === '') {
			alert.open({
	    		promptText: '请输入联系电话',
	    	})
			return ;
		}
		if(this.state.form.address.toString().replace(/\s/gi, '') === '') {
			alert.open({
	    		promptText: '请输入开票地址',
	    	})
			return ;
		}
		**/
		if (this.state.form.bankAccountNumber.toString().length > 30) {
			alert.open({
				promptText: '银行账号不能超过30个字'
			});
			return;
		}
		return true;
	}

	// 提交表单
	private async submitForm() {
		if(!this.checkForm()) {
			return ;
		}

		// 防止重复提交
		if(this.state.isSubmiting) {
			return ;
		}

		this.setState({
			isSubmiting: true
		})

		const r = await request({
	      method: "post",
	      url: `${config.CE}member/auth/company/submit/step/2`,
	      data: {
	      	authType: this.state.actiontype || 0,
	      	company: this.state.form.company,
	      	licenceCreditCode: this.state.form.licenceCreditCode,
	      	companyBank: JSON.stringify( [{
	      		bank: this.state.form.bank,
	      		bankAccountNumber: this.state.form.bankAccountNumber,
	      		phone: this.state.form.phone,
	      		address: this.state.form.address,
	      		type: 0
	      	}])
	      }
	    });

		this.setState({
			isSubmiting: false,
		})

	    if(r.code !== 1) {
	    	alert.open({
	    		promptText: r.msg,
	    	})
	    }else {
	    	this.setState({
	    		form: {
					company: '', // 企业名称
					licenceCreditCode: '', // 社会信用代码
					bank: '', // 开户银行
					bankAccountNumber: '', // 银行账号
					phone: '', // 联系电话
					address: '', // 银行地址
					type: 0,
					authType: this.state.actiontype || 0
				}
	    	}, () => {
	    		this.props.history.push('/auth/step3', {actiontype: this.state.actiontype})
	    	})
	    }
	}

}

export default ComponentAuthStep2;